<style lang="scss"  scoped>

    $primary: #DFA877;

    @media (min-width: 1200px) {

        .navbar-toggler{

            .hamburger-inner{
                transition: all 200ms;

                &:before, &:after{
                    transition: all 200ms;
                }

            }

            span{
                transition: all 200ms;

                &.no-blend-mode{
                    mix-blend-mode: unset !important;
                    color:#000;
                }

            }

            &:hover{

                .hamburger-box{

                    .hamburger-inner{
                        background-color:$primary;
                        transition: all 200ms;

                        &:before, &:after{
                            background-color:$primary;
                            transition: all 200ms;
                        }
                    }

                }

                span{
                    color: $primary;
                    transition: all 200ms;
                    mix-blend-mode: unset !important;
                }
            }

        }

    }

</style>

<template>
    <button @click="manageHamburger" class="navbar-toggler hamburger hamburger--spin hamburger--collapse position-relative d-flex align-items-center ml-4 ml-sm-3 ml-md-4 text-primary-hover" :class="'theme-' + theme" type="button" aria-expanded="false" aria-label="Toggle navigation">
        <span class="hamburger-box" :class="{'hamburger-box--close' : open}">
            <span class="hamburger-inner"></span>
        </span>
        <span class="text-theme-color ml-2 d-none d-md-block hamburger-label" :class="{'text-white' : separated_colors && theme == 'light' && !menu_open, 'no-blend-mode' : menu_open}">MENU</span>
    </button>
</template>
<script>

export default {
    props: ['themeProp'],
    data: function () {
        return {
            open:false,
            theme: this.themeProp,
            separated_colors: false,
            menu_open: false,
        };
    },
    mounted() {

        // hybrid themes: xs-sm-md-xl

        if(this.themeProp.split('-').length > 1) {
            this.theme = this.findBreakpointTheme();
            this.$eventHub.$emit('themeChange', this.theme);
            document.querySelector('nav.navbar').setAttribute('data-theme', this.theme);
        }

        if(this.themeProp.split('_').length > 1) {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            if(vw > 991) {
                this.theme = this.themeProp.split('_')[0];
                this.separated_colors = true;
            }else{
                this.theme = 'dark';
                this.separated_colors = false;
            }

        }

        this.$eventHub.$on('menuIsOpen', (payload) => {
            if(payload.open) {
                let time = payload.mobile ? 150 : 10
                setTimeout(() => {
                    this.menu_open = true;
                }, time)
                return
            }
            let time = payload.mobile ? 150 : 450
            setTimeout(() => {
                this.menu_open = false;
            }, time)
        });

        window.addEventListener('resize', () => {

            if(this.themeProp.split('-').length > 1) {
                this.theme = this.findBreakpointTheme();
                this.theme_memo = this.theme;
                this.$eventHub.$emit('themeChange', this.theme);
                document.querySelector('nav.navbar').setAttribute('data-theme', this.theme);
            }

            if(this.themeProp.split('_').length > 1) {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                if(vw > 991) {
                    this.theme = this.themeProp.split('_')[0];
                    this.separated_colors = true;
                }else{
                    this.theme = 'dark';
                    this.separated_colors = false;
                }

            }

            document.querySelector('.navbar-collapse').style = "";
            if(this.open){
                this.open = false;
                this.manageHamburger();
            }

        });
    },
    methods: {
        findBreakpointTheme() {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            let res = null;
            let themes = this.themeProp.split('-');
            if (vw < 576){
                res = 0;
            }else if (vw >= 576 && vw < 768) {
                res = 1;
            }else if (vw >= 768 && vw < 992) {
                res = 2;
            }else if (vw >= 992 && vw < 1199) {
                res = 3;
            }else if (vw >= 1200) {
                res = 4;
            }
            return themes[res];
        },
        manageHamburger() {
            //let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            let tl = gsap.timeline({});
            let hamburger =  document.querySelector('.hamburger');
            let collapse = document.querySelector('.navbar-collapse');
            //let navbar = document.querySelector('nav.navbar');

            //navbar.setAttribute('data-open', this.open);

            if(!this.open) {

                if(window.vw > 1199) {
                    try{
                        bodyScrollBar.scrollTo(0, 0, 300);
                    }catch(err){}
                }else{
                    window.scrollTo(0, 0);
                    document.querySelector('body').classList.add('position-fixed');
                }

                window.stop_scroll = true;

                //document.querySelector('.navbar').classList.add('navbar--open');
                //in both cases the language bordered block turns lighter instantly
                document.querySelector('.navbar_bordered-container--rounded-right').classList.add('triggered');
                //triggers change in other components
                this.$eventHub.$emit('menuIsOpen', {'open':true, 'mobile':(vw <= 767 ? true : false)});
                //turn hamburger into an X
                hamburger.classList.add('is-active');
                if(window.vw > 767) {

                    let elems = document.querySelectorAll('.menu-animate')
                    gsap.fromTo(elems, {autoAlpha: 0, y: 70}, {duration: .65, delay: .6, force3D:true, ease: 'Power1.easeInOut', autoAlpha:1, y: 0, stagger: 0.06,}, "-=0");

                    //case slides from top
                    //triggers lighter border in user/cart bordered block, instant if > 992
                    document.querySelector('.navbar_bordered-container--rounded-left').classList.add('triggered');
                    //collapse opens
                    tl.to(collapse, {duration: .9, delay: 0, top:"0", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {})
                        }
                    });

                }else{

                    let elems = document.querySelectorAll('.menu-animate')
                    gsap.fromTo(elems, {autoAlpha: 0, x: -30}, {duration: .6, delay: .4, force3D:true, ease: 'Power1.easeInOut', autoAlpha:1, x: 0, stagger: 0.05,}, "-=0");

                    //case slides from side
                    //collapse opens
                    tl.to(collapse, {duration: .9, delay: 0, right:"0", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {

                            })
                        }
                    });
                    tl.call(function() {
                        document.querySelector('.navbar_bordered-container--rounded-left').classList.add('triggered');
                    }, null, "-=.6");
                }

            }else{

                window.stop_scroll = false;
                document.querySelector('body').classList.remove('position-fixed');

                //triggers change in other components
                this.$eventHub.$emit('menuIsOpen', {'open':false, 'mobile':(vw <= 767 ? true : false)});
                if(window.vw > 767) {

                    let elems = document.querySelectorAll('.menu-animate');
                    tl.to(elems, {duration: .3, delay: 0, force3D:true, autoAlpha:0, y: -20, stagger: 0,}, "-=0");

                    //slides back to top
                    tl.to(collapse, {duration: .9, delay: .2, top:"-100vh", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {})
                            document.querySelector('.navbar').classList.remove('navbar--open');
                        }
                    },"-=.3");
                    //sets back the hamburger, and the border colors of the rounded blocks
                    tl.call(function() {
                        hamburger.classList.remove('is-active');
                        document.querySelector('.navbar_bordered-container--rounded-left').classList.remove('triggered');
                        document.querySelector('.navbar_bordered-container--rounded-right').classList.remove('triggered');
                        //document.querySelector('.navbar').classList.remove('navbar--open');
                    }, null, "-=.55");

                }else{

                    let elems = document.querySelectorAll('.menu-animate');
                    tl.to(elems, {duration: .3, delay: 0, force3D:true, ease: 'Power1.easeInOut', autoAlpha:0, x: -20, stagger: 0,}, "-=0");

                    //slides back to left
                    //the language bordered block turns darker instantly
                    document.querySelector('.navbar_bordered-container--rounded-left').classList.remove('triggered');
                    tl.to(collapse, {duration: .9, delay: 0, right:"100vw", force3D:true, ease: 'Power4.easeOut',
                        onComplete:() => {
                            requestAnimationFrame(() => {})
                        }
                    },"-=.3");
                    //slides from side
                    tl.call(function() {
                        hamburger.classList.remove('is-active');
                        document.querySelector('.navbar_bordered-container--rounded-right').classList.remove('triggered');
                    }, null, "-=.55");
                }
            }
            this.open = !this.open
        }
    }
}
</script>
